import { guaranteedError } from "gather-common/dist/src/public/utils";
import { encodeEncodingError } from "./encoders";
export const wrapTryCatchEncoder = (encoder, ...args) => {
    try {
        return encoder(...args);
    }
    catch (e) {
        const error = guaranteedError(e);
        return encodeEncodingError(error);
    }
};
//# sourceMappingURL=wrapTryCatchEncoder.js.map